import ReactDOM from 'react-dom';

import {DonorProfileState} from "./DonorProfileState.js";

$(function() {

	var formDataElement = document.getElementById("js-init-form-data");
	var data = JSON.parse(formDataElement.textContent);


	let donorProfile = ReactDOM.render(
			<DonorProfileState data={data}/>,
			document.getElementById("content")
	);
});
